let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kFOec"), load("hD56l"), load("3qsjq"), load("lUlCu"), load("cS7dz")]).then(() => parcelRequire('ec8HN'));